var $ = jQuery;
$(document).ready(function () {
  setTimeout(function () {
    $(".jdgm-widget .jdgm-prev-badge__stars").attr("role", "img");
    $("b.jdgm-rev__title").replaceWith(function () {
      return $("<strong />", {
        html: $(this).html(),
        class: $(this).attr("class"),
      });
    });
  }, 1000);
  console.log("ready");
});

function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

const debouncedOnDomChange = debounce(function () {
  $(
    ".testimonials-slide[aria-hidden], .product-main-slide[aria-hidden]"
  ).removeAttr("aria-hidden");
  $(".additional-checkout-buttons").each(function () {
    var ulElement = $(this).find("ul");

    if (ulElement.length > 0 && ulElement.children().length === 0) {
      ulElement.remove();
    }
  });

  // Add missing title to third-party iframes (chat widgets, pixel managers, etc.)
  var iframeIdx = 0;
  $("iframe").each(function () {
    if (!this.hasAttribute("title") || $(this).attr("title") === "") {
      var derived = $(this).attr("name") || $(this).attr("id") || $(this).attr("aria-label");
      if (!derived) {
        iframeIdx++;
        derived = "Embedded content " + iframeIdx;
      }
      $(this).attr("title", derived);
    }
  });

  // Provide accessible names for third-party anchors that render empty (e.g. Loox review badges).
  $('a[href="#loxeReviews"], a[href^="#lox"]').each(function () {
    var $a = $(this);
    if ($a.attr("aria-label")) return;
    var txt = $.trim($a.text());
    if (txt) return;
    // Fall back to nested img alt, then a generic label
    var imgAlt = $a.find("img[alt]").attr("alt");
    $a.attr("aria-label", imgAlt && $.trim(imgAlt) ? imgAlt : "Read customer reviews");
  });

  // Warn users that a link opens in a new window (WCAG 3.2.5 / F22).
  // Add a visually-hidden hint so screen reader users know, without altering visual UI.
  $('a[target="_blank"]:not([data-nw-a11y])').each(function () {
    var $a = $(this);
    $a.attr("data-nw-a11y", "1");
    var existingLabel = ($a.attr("aria-label") || "").toLowerCase();
    var existingTitle = ($a.attr("title") || "").toLowerCase();
    var hasWarning = existingLabel.indexOf("new window") !== -1 ||
                     existingLabel.indexOf("new tab") !== -1 ||
                     existingTitle.indexOf("new window") !== -1 ||
                     existingTitle.indexOf("new tab") !== -1 ||
                     $a.find('.a11y-newwin-hint').length > 0;
    if (hasWarning) return;
    $a.append(' <span class="visually-hidden a11y-newwin-hint">(opens in new window)</span>');
  });
}, 500);
const observer = new MutationObserver((mutations) => {
  debouncedOnDomChange();
});
// Configuration of the observer
const config = {
  childList: true, // Observe direct children
  subtree: true, // and lower descendants
  attributes: true, // Observe attribute changes
};
// Start observing the document body (or any specific element)
observer.observe(document.body, config);

$(window).on("load", function () {
  setTimeout(function () {
    var i = 1;
    $("#web-pixels-manager-sandbox-container iframe").each(function () {
      $(this).attr("title", "web pixels iframe" + " " + i);
      i++;
    });
    // Run initial iframe title pass (for iframes already present on load)
    debouncedOnDomChange();
  }, 2000);

  console.log("load");
});
